<template>
  <div>
    <v-alert dense outlined type="info" class="mb-4">
      Bu adım operasyon başlamadan önce TYA'nın faturalandırma kapsamını
      özetler. Fatura sahibi, ilişki, ürün, resmi fatura ve düzeltme adayı
      bilgileri operasyon kapsamı üzerinden beslenecek.
    </v-alert>

    <v-row dense>
      <v-col cols="12" md="6">
        <v-card outlined class="h-100">
          <v-card-title class="py-3">Kapsam</v-card-title>
          <v-card-text>
            <div class="scope-row">
              <span>Giriş tipi</span>
              <strong>{{ sourceTypeLabel }}</strong>
            </div>
            <div class="scope-row">
              <span>Risk tipi</span>
              <strong>{{ issueLabel }}</strong>
            </div>
            <div class="scope-row">
              <span>TYA</span>
              <strong>
                {{ getFirstValue(["cluster_name", "clusterName"]) }}
              </strong>
            </div>
            <div class="scope-row">
              <span>Müşteri</span>
              <strong>
                {{ getFirstValue(["customer_name", "customerName"]) }}
              </strong>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card outlined class="h-100">
          <v-card-title class="py-3">Faturalama Durumu</v-card-title>
          <v-card-text>
            <div class="state-grid">
              <v-chip small outlined :color="riskColor">
                {{ hasIssue ? "Risk var" : "Risk yok / bilinmiyor" }}
              </v-chip>
              <v-chip small outlined color="grey">
                Fatura sahibi:
                {{ getFirstValue(["owner_name", "ownerName"]) }}
              </v-chip>
              <v-chip small outlined color="grey">
                İlişki:
                {{ getFirstValue(["relation_status", "relationStatus"]) }}
              </v-chip>
              <v-chip small outlined color="grey">
                Ürün: {{ getFirstValue(["product_status", "productStatus"]) }}
              </v-chip>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "OperationScopeOverview",
  props: {
    source: {
      type: Object,
      default: null,
    },
    issueLabel: {
      type: String,
      default: "-",
    },
  },
  computed: {
    sourceTypeLabel() {
      if (!this.source) {
        return "Manuel";
      }

      if (
        this.source.type === "portfolio_issue" ||
        this.source.type === "risk"
      ) {
        return "Portföy risk satırı";
      }

      return this.source.type || "Manuel";
    },
    hasIssue() {
      return Boolean(
        this.source &&
          (this.source.type === "portfolio_issue" ||
            this.source.type === "risk")
      );
    },
    riskColor() {
      return this.hasIssue ? "error" : "success";
    },
  },
  methods: {
    getFirstValue(keys) {
      if (!this.source) {
        return "-";
      }

      const value = keys
        .map((key) => this.source[key])
        .find((candidate) => candidate !== undefined && candidate !== null);

      if (value === undefined || value === null || value === "") {
        return "-";
      }

      return value;
    },
  },
};
</script>

<style scoped>
.scope-row {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 7px 0;
}

.scope-row + .scope-row {
  border-top: 1px solid #eeeeee;
}

.scope-row span {
  color: #757575;
}

.state-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
</style>
